import type { Event } from '@/services/sched/types'

export const PARTY_EVENT_NAME = 'Party at the Top of the World'

/**
 * Finds the "Party at the Top of the World" event within a day's events, if present.
 * Pure so it can be memoized during render instead of derived through an effect.
 */
export const findPartyEvent = (events: Event[]): Event | undefined =>
  events.find((event) => event.name === PARTY_EVENT_NAME)
